import { styled, Typography } from '@mui/material';

export const ApproveText = styled(Typography)(({ theme }) => ({
    color: theme.palette.success.main,
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 700,
}));

export const RejectText = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.main,
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 700,
}));

export const ReplaceText = styled(Typography)(({ theme }) => ({
    color: theme.palette.warning.main,
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 700,
}));
